import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Colors, Icon } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';

type Props = {
  children: ReactNode;
  isVisible: boolean;
  setIsVisible: (param: boolean) => void;
};

export const FloatingPopup = ({ children, isVisible, setIsVisible }: Props) => {
  const iconSize = 23;

  return !isVisible ? null : (
    <Outer>
      <IconWrapper
        data-testid="floating-popup-close-icon"
        onClick={() => {
          setIsVisible(false);
        }}
      >
        <Icon color="neutral600" name="formX" size={iconSize} />
      </IconWrapper>
      {children}
    </Outer>
  );
};

const Outer = styled.div`
  background-color: ${Colors.neutral100};
  border-top: 3px solid ${Colors.neutral300};
  display: grid;
  place-items: center;
  width: 100%;
  // These styles help the popup stick to the bottom of the mobile and tablet view
  padding: 20px 20px 67px 4%;
  bottom: 0;
  position: fixed;
  z-index: 10;
  ${mediaQueries.tablet} {
    bottom: 0;
    padding-bottom: 67px;
  }
  ${mediaQueries.desktop} {
    border: 1px solid ${Colors.neutral300};
    border-radius: 5px;
    height: max-content;
    max-width: 300px;
    padding: 20px 20px 20px 21px;
    // These styles help the popup stick to the left side of the desktop view
    position: sticky;
    bottom: 64px;
    right: 76%;
    width: 100%;
    &:hover,
    &:focus,
    &:active {
      box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
    }
  }
`;

const IconWrapper = styled.button`
  position: absolute;
  top: 10%;
  right: 4%;
  background: none;
  ${mediaQueries.tablet} {
    top: 24%;
  }
  ${mediaQueries.desktop} {
    top: 15px;
  }
`;
